import React from 'react'
import { createRoot } from 'react-dom/client'

import { Locale } from '@insight/toolkit-react'
import { getCurrentLocale } from '@insight/toolkit-utils/lib/helpers'
import './scss/index.scss'
import WrapperComponent from './routes'
import { getAccountInformation, getFeatureFlags, getContractDetils, getTranslations } from './api'
import { getEntitlementQuery }  from 'app-api-user-service'
import { INSIGHT_CURRENT_LOCALE_COOKIE_NAME } from './constants'

const parseBoolean = (value) => value === true || value === 'true'
const locale = getCurrentLocale(INSIGHT_CURRENT_LOCALE_COOKIE_NAME)

const placeholder = document.getElementById('react-app-search')
const root = createRoot(placeholder)
const landingPageInfo = {
  initQuery: placeholder.dataset.initquery,
  isBrandPage: parseBoolean(placeholder.dataset.isbrandpage),
  isLandingPage: placeholder.dataset.islandingpage,
  productSet: placeholder.dataset.productset,
  transformQuery: parseBoolean(placeholder.dataset.transformQuery),
}
const queryString = window.location.search
const params = new URLSearchParams(queryString)
const licenseContractIds = params.get('licenseContractIds')
const selectedContractIDs = licenseContractIds
  ?.split(',')
  .map((contractId) => contractId.trim())
  .filter(Boolean)

function renderApp() {
    Promise.all([
        getAccountInformation(),
        getFeatureFlags(),
    ])
    .then(([headerInfo]) =>
       Promise.all([
        getTranslations(headerInfo),
        Promise.resolve(getContractDetils(headerInfo)).catch((error) => {
          console.error('Error getting contract details for Coveo search', error)
          return null
        }),
        getEntitlementQuery({isLoggedIn: headerInfo?.isLoggedIn, selectedContractIDs})
              .catch((error) => {
                console.error('Error building entitlement query for Coveo search', error)
                return null
              }),
      ]).then(([translationsData, contract, entitlementData]) => [
        translationsData,
        contract,
        entitlementData === null ? null : (entitlementData?.query || ''),
      ])
    )
    .then(([
            {
                cdmUid,
                currencyCode,
                domainUrl,
                isLoggedIn,
                isIPSUser,
                webGroupId,
                salesOrg,
                sessionId,
                isHybridXEnabled,
                permissions,
                webGroupPermissions,
                showProductImages,
                userType,
                coveoData,
            },
            contract,
            entitlementQuery
        ]) => {

        const mergedCoveoData = {...coveoData, entitlementQuery}

        //const isMultipleContract = contract && contract?.contractType === "All"
        root.render(
            <Locale
                value={{
                    locale,
                    cdmUid,
                    contract,
                    currencyCode,
                    domainUrl,
                    isLoggedIn,
                    isIPSUser,
                    webGroupId,
                    salesOrg,
                    sessionId,
                    isHybridXEnabled,
                    permissions,
                    webGroupPermissions,
                    showProductImages,
                    userType,
                    coveoData: mergedCoveoData,
                    selectedContractIDs
                }}
            >
                <WrapperComponent landingPageInfo={landingPageInfo} />
            </Locale>
        )
    })
}

renderApp()
